export default {
  nestedRubrics(rubrics) {
    let result = rubrics || [];

    rubrics.forEach(rubric => {
      if (rubric.children && rubric.children.length) {
        result = [...result, ...this.nestedRubrics(rubric.children)];
      }
    });

    return result;
  },

  filterRubricsByExporter(rubrics = [], is_exporter = false) {
    return rubrics
      .filter(rubric => rubric.is_exporter === is_exporter)
      .map(rubric => {
        return {
          ...rubric,
          children:
            rubric.children && rubric.children.length
              ? this.filterRubricsByExporter(rubric.children, is_exporter)
              : []
        };
      });
  },

  isCompanyInfoFalseSymbols(value = "", lang = "rus") {
    const regex =
      lang === "rus" ? /[А-Яа-я0-9 ,.!?"';:\s+]/g : /[A-Za-z0-9 ,.!?"';:\s+]/g;
    return (value.match(regex)?.length || 0) < Math.abs(value.length / 2);
  }
};
